export enum ListModeratorActionTypes {
  FETCHING = 'moderators/FETCHING',
  RECEIVED = 'moderators/RECEIVED',
  ERROR = 'moderators/LIST-ERROR',
}
